import { useQuery } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { ApiError } from '@root/globalTypes';
import { queryKeys } from '@utils/consts';
import { StagesDropdownRespSuccess } from './types';
import { useAppContext } from '@contexts/app';
import { useQueryParams } from '@hooks/queryParams';

export const useStagesDropdown = () => {
  const { isDropdownEnabled: enabled } = useAppContext();

  const {
    params: { workflowIds },
    parseParams,
  } = useQueryParams();

  const queryParams = parseParams({ workflowIds }, { arrayFormat: 'bracket' });

  const { data, error, isPending } = useQuery<StagesDropdownRespSuccess, ApiError>({
    queryKey: [...queryKeys.dropdowns.stages, queryParams],
    queryFn: () => queryFetch({ url: `dropdowns/stages${queryParams}` }),
    placeholderData: (previousData) => previousData as StagesDropdownRespSuccess,
    enabled,
    retry: 2,
  });

  return {
    data,
    error,
    isLoading: isPending && enabled,
  };
};
